module.exports = __webpack_public_path__ + "13a676f740ad53c0ef3e166105add15c.svg";